<template>
  <base-card class="daily-health-check-container">
    <div class="row align-items-center justify-content-between ml-1 p-3 flex-nowrap">
      <div class="col-xs-3 pr-3 ml-1">
        <font-awesome-icon :icon="['fal', 'comment-alt-medical']" class="health-check-icon"></font-awesome-icon>
      </div>
      <div class="col-xs-9 mr-auto">
        <h5 class="m-0 p-0">{{ $t('healthStatusCard.healthStatus') }}</h5>
        <p class="m-0 p-0">{{ $t('healthStatusCard.lastUpdated') }}: {{ lastHealthCheck }}</p>
      </div>
      <div class="col-xs-3 mr-2">
        <font-awesome-icon class="chevron" :icon="['fal', 'chevron-right']"></font-awesome-icon>
      </div>
    </div>
  </base-card>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import BaseCard from '../base-card/base-card.vue';
import common from "@/mixins/common";

export default {
  name: 'DailyHealthCheckCard',
  components: {
    BaseCard,
  },
  mixins: [common],
  computed: {
    ...mapState(['currentHealthStatus']),
    lastHealthCheck() {
      this.log('DailyHealthCheckCard -> lastHealthCheck', 'currentHealthStatus', this.currentHealthStatus);
      if (this.currentHealthStatus) {
        const updatedAt = new Date(this.currentHealthStatus.meta.updated_at);
        return format(updatedAt, 'MM/dd/yy - hh:mm a');
      }
      return 'N/A';
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">

</style>
